import { createContext } from '../ContextSelector';
var HoverContext = createContext();
export default HoverContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/HoverContext.js
// module id = ./node_modules/rc-table/es/context/HoverContext.js
// module chunks = 0